/**
 * @file 获取资源列表
 * @author liudy
 */

import Api from '../../../path'
import { SortType } from '@umu/umu-types';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IGetResourceInput {
    order_by: string;
    sort: SortType;
    page: number;
    size: number;
    status: string;
}

type IOutput = IDocResourceInfo;

export const getResourceList = fetchDataSync((data: IGetResourceInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.GET_RESOURCE_LIST, data).then((res: IListResponse<IOutput>) => {
        return res;
    });
});
